export default "__VITE_ASSET__3RGZcuMt__"